import React, { Component } from 'react';
import './Profile.css';

import { withFirebase } from '../firebase';
import { AuthUserContext, withAuthorization } from '../session';

import { ToastContainer } from 'react-toastr';

const Profile = () => (
  <AuthUserContext.Consumer>
    {ctx => (
      <div>
        <img
          className="Profile-logo"
          src={process.env.PUBLIC_URL + '/img/logo.png'}
          alt="logo"
        />
        <h1 className="Profile-title">Edit Profile <a href="http://sonad.io/instruction.html#edit" target="_blank" rel="noopener noreferrer" className="Help">?</a></h1>

        <ProfileForm authUser={ctx.authUser} />
      </div>
    )}
  </AuthUserContext.Consumer>
);

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  street: '',
  town: '',
  state: '',
  zip: '',
  phone: '',
  email: '',
  company: '',
  level: 1,
  error: null,
};

const INPUT_DATA = [
  {
    type: 'text',
    name: 'firstName',
    label: 'First Name',
    required: true
  },
  {
    type: 'text',
    name: 'lastName',
    label: 'Last Name',
    required: true
  },
  {
    type: 'text',
    name: 'street',
    label: 'Street',
    required: true
  },
  {
    type: 'text',
    name: 'town',
    label: 'Town/city',
    required: true
  },
  {
    type: 'select',
    name: 'state',
    label: "State",
    required: true,
    options: [
      { value: "AL", label: "Alabama" },
      { value: "AK", label: "Alaska" },
      { value: "AZ", label: "Arizona" },
      { value: "AR", label: "Arkansas" },
      { value: "CA", label: "California" },
      { value: "CO", label: "Colorado" },
      { value: "CT", label: "Connecticut" },
      { value: "DE", label: "Delaware" },
      { value: "DC", label: "District Of Columbia" },
      { value: "FL", label: "Florida" },
      { value: "GA", label: "Georgia" },
      { value: "HI", label: "Hawaii" },
      { value: "ID", label: "Idaho" },
      { value: "IL", label: "Illinois" },
      { value: "IN", label: "Indiana" },
      { value: "IA", label: "Iowa" },
      { value: "KS", label: "Kansas" },
      { value: "KY", label: "Kentucky" },
      { value: "LA", label: "Louisiana" },
      { value: "ME", label: "Maine" },
      { value: "MD", label: "Maryland" },
      { value: "MA", label: "Massachusetts" },
      { value: "MI", label: "Michigan" },
      { value: "MN", label: "Minnesota" },
      { value: "MS", label: "Mississippi" },
      { value: "MO", label: "Missouri" },
      { value: "MT", label: "Montana" },
      { value: "NE", label: "Nebraska" },
      { value: "NV", label: "Nevada" },
      { value: "NH", label: "New Hampshire" },
      { value: "NJ", label: "New Jersey" },
      { value: "NM", label: "New Mexico" },
      { value: "NY", label: "New York" },
      { value: "NC", label: "North Carolina" },
      { value: "ND", label: "North Dakota" },
      { value: "OH", label: "Ohio" },
      { value: "OK", label: "Oklahoma" },
      { value: "OR", label: "Oregon" },
      { value: "PA", label: "Pennsylvania" },
      { value: "RI", label: "Rhode Island" },
      { value: "SC", label: "South Carolina" },
      { value: "SD", label: "South Dakota" },
      { value: "TN", label: "Tennessee" },
      { value: "TX", label: "Texas" },
      { value: "UT", label: "Utah" },
      { value: "VT", label: "Vermont" },
      { value: "VA", label: "Virginia" },
      { value: "WA", label: "Washington" },
      { value: "WV", label: "West Virginia" },
      { value: "WI", label: "Wisconsin" },
      { value: "WY", label: "Wyoming" },
    ]
  },
  {
    type: 'text',
    name: 'zip',
    label: 'Zip',
    required: true
  },
  {
    type: 'text',
    name: 'phone',
    label: 'Phone',
    required: true
  },
  {
    type: 'text',
    name: 'company',
    label: 'Company (if business account)'
  }
]

let toastContainer;

class ProfileFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };

    this.updateEmailAndVerify = this.updateEmailAndVerify.bind(this)
    this.sendVerificationEmail = this.sendVerificationEmail.bind(this)
  }

  componentDidMount() {
    this.props.firebase.user(this.props.authUser.uid).once('value', snapshot => {
      let got_user = snapshot.val() != null
      if (got_user) this.setState(snapshot.val());
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmit = event => {
    const { email, firstName, lastName, street, town, state, zip, phone, company, level } = this.state;

    this.props.firebase
      .user(this.props.authUser.uid)
      .set({
        firstName,
        lastName,
        street,
        town,
        state,
        zip,
        phone,
        email,
        company,
        level
      })
      .then(() =>
        toastContainer.success('Success! Your profile has been updated.', '', {
          timeOut: 4000,
        })
      );

    event.preventDefault();
  };

  sendVerificationEmail() {
    let {authUser} = this.props
    authUser.sendEmailVerification().then(function() {
      toastContainer.success('Sent,please check your email to verify', '', {
        timeOut: 4000,
      })
    }).catch(function(err) {

    })
  }

  updateEmailAndVerify() {
    let {email} = this.state
    let {firebase} = this.props
    let auth_user = firebase.auth_user()
    if (email.toLowerCase() !== auth_user.email.toLowerCase()) {
      // First change email for user
      auth_user.updateEmail(email).then(() => {
        this.sendVerificationEmail()
      }).catch((err) => {
        console.error(err)
        toastContainer.error(err.message)
      })
    } else this.sendVerificationEmail()
  }

  renderInputRows() {
    return INPUT_DATA.map((input_object) => {
      let input_el = null
      let value
      let attrs = input_object.attrs || {}
      value = this.state[input_object.name]
      input_el = <input type={input_object.type}
                      name={input_object.name}
                      value={value}
                      placeholder={input_object.label}
                      onChange={input_object.onChange != null ? input_object.onChange : this.onChange}
                      required={input_object.required}
                      disabled={input_object.disabled || false}
                      {...attrs}
                />
      return (
        <div className="row" key={input_object.name}>
          <div className="col-sm-4 labelCol">
            <label htmlFor={input_object.name} data-tip={input_object.description || ''} title={input_object.description || ''}>{ input_object.label }</label>
          </div>
          <div className="col-sm-8">
            { input_el }
          </div>
        </div>
      )
    })
  }

  unverified() {
    let {firebase} = this.props
    return firebase.email_verified() == null
  }

  renderVerify() {
    let {email} = this.state
    return (
      <div>
        <h2 className="Profile-subtitle">Email not yet verified</h2>
        <p>Please confirm your email by requesting a verification email below.</p>
        <input type="email" name="email" onChange={this.onChange} value={email||''} />
        <button type="button" onClick={this.updateEmailAndVerify}>Verify</button>
      </div>
      )
  }

  render() {
    const { error, email } = this.state;
    let content
    if (this.unverified()) {
      content = this.renderVerify()
    } else {
      content = (
        <div>
          <h2 className="Profile-subtitle">Please fill in a few pieces of information for your profile</h2>
          <p>Your email <b>{ email }</b> is verified.</p>
          {this.renderInputRows() }
          {error && <p>{error.message}</p>}
          <button type="submit">Save</button>
        </div>
      )
    }
    return (
      <form onSubmit={this.onSubmit} className="Sonad-form Profile-form">

        { content }

        <ToastContainer
          ref={ref => (toastContainer = ref)}
          className="toast-bottom-right"
        />
      </form>
    );
  }
}

const ProfileForm = withFirebase(ProfileFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Profile);

export { ProfileForm };
